export default __webpack_public_path__ + "static/media/DashboardArrow.f9da34e5.svg";